module.exports = __webpack_public_path__ + "assets/cc0c637659c986fd7f4976d988cd5c2a.png";